module.exports = __webpack_public_path__ + "img/成都市第一人民医院.d1e8e495.png";